import { SimpleRope } from '@pixi/mesh-extras';

SimpleRope.prototype._renderCanvas = function _renderCanvas(renderer) {
  if (this.autoUpdate || this.geometry._width !== this.shader.texture.height) {
    this.geometry._width = this.shader.texture.height;
    this.geometry.update();
  }
  if (this.shader.update) {
    this.shader.update();
  }
  this.calculateUvs();
  this.material._renderCanvas(renderer, this);
};
//# sourceMappingURL=SimpleRope.mjs.map
